import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'searchPipe',
})
export class SearchPipe implements PipeTransform {
    transform(options: Array<any>, search: string) {
        if (options.length > 0) {
            if (typeof search === 'undefined') {
                return options;
            }
            return options.filter(str => {
                return (typeof search === 'undefined') ||
                    (search.trim()).length === 0 ||
                    str.text.toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) > -1;
            });
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/pipes/search.pipe.ts